__webpack_require__.p = "https://assets-01.periodica.press/7337c4f-19131228349/";